// extracted by mini-css-extract-plugin
export default {"root":"Catalog_root__GpLN4","actions":"Catalog_actions__P3iec"};